<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>用户管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户管理列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>用户课程管理列表</span>
        </div>
        <div style="display: flex">
          <el-button @click="selectCourse()" size="small" icon="el-icon-plus" type="success">添加课程</el-button>
          <el-button @click="back()" size="small" icon="el-icon-back" type="primary">返回列表</el-button>
        </div>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe size="small" style="width: 100%" v-loading="loading">
          <el-table-column align="center" prop="id" label="UID" width="80"></el-table-column>
          <el-table-column align="center" label="课程类型" width="120">
            <template #default="scope">
              <el-tag type="success" v-if="scope.row.course_id">课程</el-tag>
              <el-tag type="danger" v-else>套餐</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="course_title" label="课程名称" width="*"></el-table-column>
          <el-table-column align="center" prop="etime" width="160" label="到期日期"></el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template #default="scope">
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">取消课程</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="total, prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 选择课程 -->
    <el-dialog title="选择套餐课程" width="60%" :visible.sync="dialogTableVisible">
      <el-form :inline="true">
        <el-form-item>
          <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
        </el-form-item>
      </el-form>

      <el-table border size="mini" :data="gridData">
        <el-table-column label="分类" width="200">
          <template #default="scope">{{scope.row.column_name}} - {{scope.row.subject_name}}</template>
        </el-table-column>
        <el-table-column property="title" label="名称" width="*"></el-table-column>
        <el-table-column label="操作" width="90">
          <template #default="scope">
            <el-button v-if="scope.row.selected" size="mini" type="info" plain disabled>已开通</el-button>
            <el-button v-else size="mini" type="primary" @click="select_model_item(scope.row,scope.$index)">开通</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <el-pagination class="left" @current-change="handleCurrentChangeGrid" :current-page="pageGrid" background layout="total,prev, pager, next" :total="countGrid"></el-pagination>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      uid: 0,
      course_ary: [],
      gridData: [],
      loading: true,
      pageGrid: 0,
      countGrid: 0,
      search: {
        type: "",
        keys: "",
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var query = that.$route.query;
    if (query.uid) {
      that.uid = query.uid;
    }
    that.getList();
  },
  methods: {
    selectCourse() {
      var that = this;
      that.dialogTableVisible = true;
      that.getGridData();
    },

    getIndex() {
      var that = this;
      that.getGridData();
    },

    getClearIndex() {
      this.search.keys = "";
      this.search.type = "";
      this.getGridData();
    },

    select_model_item(ids, index) {
      var that = this;
      that.gridData[index].selected = 1;
      that.course_ary.push(ids);
      that.setOpenCourse(ids);
    },

    deleteCourse(ids) {
      console.log(ids);
      var that = this;
      that.course_ary.splice(ids, 1);
      that.ruleForm.course_ary.splice(ids, 1);
      //that.ruleForm.course_ary.push(ids);
    },

    handleCurrentChangeGrid(currentPage) {
      var that = this;
      that.pageGrid = currentPage;
      that.getGridData();
    },

    add() {
      this.$router.push("/admin/add");
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("确认取消此课程吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios.post("/setCancelCourse", { id: ids }).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getList();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {});
    },

    getGridData() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page_grid");
      that.pageGrid = curr_page ? curr_page - 0 : that.pageGrid;
      formData.page = that.pageGrid;
      formData.limit = that.limit;
      formData.keyword = that.search.keys;
      formData.type = that.search.type;
      formData.id = that.uid;
      that.axios.post("/getPageCourse", formData).then((res) => {
        if (res) {
          that.gridData = res.data.data;
          that.countGrid = res.data.total;
          that.pageGrid = curr_page ? curr_page : that.pageGrid;
          curr_page ? sessionStorage.removeItem("curr_page_grid") : "";
          that.loading = false;
        }
      });
    },

    setOpenCourse(e) {
      var that = this;
      that.axios
        .post("/setOpenCourse", { id: that.uid, course_id: e.id })
        .then((res) => {
          that.getList();
          this.$message({
            type: "success",
            message: res.msg,
          });
        });
    },

    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.uid = that.uid;
      that.axios.post("/getYtkUsersCourse", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
    /**
     * 返回
     */
    back() {
      this.$router.push("/users/index");
    },
  },
};
</script>
<style>
</style>